import { DataBean } from "../DataBean";

export class CurrentFlights extends DataBean {

  public async getCurrentFlights(page: number, rows: number, props: any): Promise<any> {
    return this.getCustomService(
      "ProcessFlow",
      "com.advantage.shared.Report_getCurrentFlights_Number_Number_java.util.Map",
      [page, rows, props]
    );
  }

}
